import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Avatar } from "@mui/material";
import { ClassNameMap } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import { UserBriefInfoDto } from "@growth-machine-llc/stridist-api-client";
import { JourneyAnchors } from "../../constants";

const OVERLAP_SPACING = 2;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row-reverse",
    marginRight: theme.spacing(OVERLAP_SPACING),
  },

  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    border: `2px solid ${theme.palette.common.white}`,
    borderRadius: theme.spacing(1),
    marginRight: theme.spacing(-OVERLAP_SPACING),
  },
}));

export type StackedClientsAvatarsClassKey = "root" | "avatar";

export interface StackedClientsAvatarsProps extends BoxProps {
  clients: UserBriefInfoDto[];
  limit?: number;
  classes?: Partial<ClassNameMap<StackedClientsAvatarsClassKey>>;
}

export function StackedClientsAvatars(props: StackedClientsAvatarsProps) {
  const { className, clients, limit = 4, classes = {}, ...other } = props;
  const s = useStyles();

  const visible = clients.slice(0, limit);

  return (
    <Box className={clsx(s.root, classes.root, className)} {...other}>
      {clients.length > limit && (
        <Avatar
          className={clsx(s.avatar, classes.avatar)}
          variant={"square"}
          children={clients.length - limit}
        />
      )}
      {visible.map(({ id, displayName, photoUrl }, index) => (
        <Avatar
          className={clsx(s.avatar, classes.avatar, {
            [JourneyAnchors.FIRST_AVATAR]: index === visible.length - 1,
          })}
          key={id}
          src={photoUrl}
          alt={displayName}
          variant="square"
        />
      ))}
    </Box>
  );
}
